import React from "react";
import Loader from '../../../components/Loader';
import Page from '../../../components/Page';
import HTTPManager from "../../../utils/httpRequestManager";
import TableView from '../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import Iconify from '../../../components/Iconify';
import FormManager from "../../../components/formComponents/FormManager";
import schema from './schema';
import {Box, Grid, Card,  Container, Typography, Stack} from '@mui/material';
import FButton from '../../../components/formComponents/components/button'; 
import { checkButtonAccess } from "../../../utils/protector";
const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class Users extends React.Component{
    httpManager = new HTTPManager(); 
    constructor(){
        super();
        this.state={
            isLoading:false,
            schema:{},
            employeelist:[],
            addForm: false,
            selectedEmployee:{},
            columns:[
                {
                    field: 'firstName',
                    headerName: 'Name',
                    minWidth:200,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                            {params.row.cnUserFirstName === ''? '--' : params.row.cnUserFirstName + ' ' + params.row.cnUserLastName }
                        </div>
                    )
                },
                {
                    field: 'email',
                    headerName: 'Email',
                    minWidth:200,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                           {params.row.cnUserEmail === ''? '--' : params.row.cnUserEmail}
                        </div>
                    )
                },
                {
                    field: 'staff_role',
                    headerName: 'Role',
                    minWidth:150,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                          {params.row.userRole === ''? '--' : params.row.userRole}
                            {/* {params.row.roleId} */}
                        </div>
                    )
                },
                {
                  field: 'passcode',
                  headerName: 'PassCode', 
                  editable: false,minWidth:100,
                  renderCell: (params) => (
                      <div>
                         {params.row.cnUserCode === ''? '--' : params.row.cnUserCode}
                      </div>
                  )
              },
                // {
                //     field: 'status',
                //     headerName: 'Status', 
                //     minWidth:100,
                //     editable: false,
                //     renderCell: (params) => (
                //        <div style={{textTransform:'capitalize'}}> 
                //             {params.row.cnUserStatus === '1' ? 'Active' : 'Inactive'}
                //         </div>
                //     )
                // },
                {
                    field: 'Action',
                    headerName:'Actions',
                    flex:1,
                    minWidth:100,
                    renderCell: (params) => (
                        this.getActions(params)                    
                    ),
                }
                
            ] 
        }
        this.handleCloseform = this.handleCloseform.bind(this); 
        this.updateRecord = this.updateRecord.bind(this);
        this.resendmail = this.resendmail.bind(this);
        this.onStateChange = this.onStateChange.bind(this);
        this.onUpdateRole = this.onUpdateRole.bind(this);
      }
 
      onUpdateRole(values){ 
        var schema = Object.assign({}, this.state.schema);
                var properties = Object.assign([], this.state.schema.properties);
                var props=[];
                properties.forEach((field,i)=>{ 
                    if(field.component === 'Permission'){
                        field.permissionType = values['cnUserRole'] === '2' ? 'Admin' : 'Staff'
                        if(field.permissionType === 'Admin'){
                            field.permissions = [
                                {
                                    key:"Region",
                                    label:"Region Management",
                                    options:[
                                        {
                                            "label":"Read",
                                            "Value" :"R"
                                        },
                                        {
                                            "label":"Write",
                                            "Value" :"W"
                                        }
                                    ]
                                },
                                {
                                    key:"User",
                                    label:"User Management",
                                    subLevel:[
                                        {
                                            key:"Staff",
                                            label:"Staff Management",
                                            options:[
                                                {
                                                    "label":"Read",
                                                    "Value" :"R"
                                                },
                                                {
                                                    "label":"Write",
                                                    "Value" :"W"
                                                }
                                            ]
                                        },
                                        {
                                            key:"MasterAgents",
                                            label:"Master Agents Management",
                                            options:[
                                                {
                                                    "label":"Read",
                                                    "Value" :"R"
                                                },
                                                {
                                                    "label":"Write",
                                                    "Value" :"W"
                                                }
                                            ]
                                        },
                                        {
                                            key:"Agents",
                                            label:"Agents Management",
                                            options:[
                                                {
                                                    "label":"Read",
                                                    "Value" :"R"
                                                },
                                                {
                                                    "label":"Write",
                                                    "Value" :"W"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    key:"Merchant",
                                    label:"Merchant Management",
                                    subLevel:[
                                        {
                                            key:"Create",
                                            label:"Create Merchant",
                                            options:[
                                                {
                                                    "label":"Allow",
                                                    "Value" :"Y"
                                                } 
                                            ]
                                        },
                                        {
                                            key:"Review",
                                            label:"Review Merchant",
                                            subLevel:[
                                                {
                                                    key:"AssignToMe",
                                                    label:"Assign To Me",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"AssignToStaff",
                                                    label:"Assign To Staff",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"AssignToMA",
                                                    label:"Assign To Master Agent",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"AssignToA",
                                                    label:"Assign To Agent",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"Unassign",
                                                    label:"Unassign",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"EditMerchant",
                                                    label:"Edit Merchant",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                            ]
                                        },
                                        {
                                            key:"Rejected",
                                            label:"Rejected Merchants",
                                            options:[
                                                {
                                                    "label":"Show All",
                                                    "Value" :"All"
                                                } ,
                                                {
                                                    "label":"Show Assigned",
                                                    "Value" :"Assigned"
                                                } 
                                            ]
                                        },
                                        {
                                            key:"Deactivated",
                                            label:"Deactivated Merchants",
                                            options:[
                                                {
                                                    "label":"Show All",
                                                    "Value" :"All"
                                                } ,
                                                {
                                                    "label":"Show Assigned",
                                                    "Value" :"Assigned"
                                                } 
                                            ]
                                        }
                                    ]
                                }
                            ] 
                        }
                        else{
                            field.permissions = [ 
                                {
                                    key:"User",
                                    label:"User Management",
                                    subLevel:[ 
                                        {
                                            key:"MasterAgents",
                                            label:"Master Agents Management",
                                            options:[
                                                {
                                                    "label":"Read",
                                                    "Value" :"R"
                                                },
                                                {
                                                    "label":"Write",
                                                    "Value" :"W"
                                                }
                                            ]
                                        },
                                        {
                                            key:"Agents",
                                            label:"Agents Management",
                                            options:[
                                                {
                                                    "label":"Read",
                                                    "Value" :"R"
                                                },
                                                {
                                                    "label":"Write",
                                                    "Value" :"W"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    key:"Merchant",
                                    label:"Merchant Management",
                                    subLevel:[
                                        {
                                            key:"Create",
                                            label:"Create Merchant",
                                            options:[
                                                {
                                                    "label":"Allow",
                                                    "Value" :"Y"
                                                } 
                                            ]
                                        },
                                        {
                                            key:"Review",
                                            label:"Review Merchant",
                                            subLevel:[
                                                {
                                                    key:"AssignToMe",
                                                    label:"Assign To Me",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"AssignToStaff",
                                                    label:"Assign To Staff",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"AssignToMA",
                                                    label:"Assign To Master Agent",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"AssignToA",
                                                    label:"Assign To Agent",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"Unassign",
                                                    label:"Unassign",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                                {
                                                    key:"EditMerchant",
                                                    label:"Edit Merchant",
                                                    options:[
                                                        {
                                                            "label":"Allow",
                                                            "Value" :"Y"
                                                        } 
                                                    ]
                                                }, 
                                            ]
                                        },
                                        {
                                            key:"Rejected",
                                            label:"Rejected Merchants",
                                            options:[
                                                {
                                                    "label":"Show All",
                                                    "Value" :"All"
                                                } ,
                                                {
                                                    "label":"Show Assigned",
                                                    "Value" :"Assigned"
                                                } 
                                            ]
                                        },
                                        {
                                            key:"Deactivated",
                                            label:"Deactivated Merchants",
                                            options:[
                                                {
                                                    "label":"Show All",
                                                    "Value" :"All"
                                                } ,
                                                {
                                                    "label":"Show Assigned",
                                                    "Value" :"Assigned"
                                                } 
                                            ]
                                        }
                                    ]
                                }
                            ] 
                        }
                    }    
                    else{
                        field.value = values[field.name]
                    }
                    props.push(field);
                    if(i === properties.length-1){ 
                        schema.properties = props; 
                        //console.log(schema)
                        schema.force = true
                        this.setState({schema: schema},()=>{
                            this.setState({addForm: true})
                        })
                    }
                })
      }

    onStateChange(values){
        this.httpManager.postRequest('lookup/getRegionByState', {stateId: values.cnUserState}).then(response=>{
            var regionId = response.data.length > 0 ? response.data[0].id : ''
            //console.log(regionId)
                var schema = Object.assign({}, this.state.schema);
                var properties = Object.assign([], this.state.schema.properties);
                var props=[];
                properties.forEach((field,i)=>{
                    if(field.name === 'cnUserRole'){
                        field.permissionType = field.value === '2' ? 'Admin' : 'Staff'
                    }  

                    if(field.name === 'cnUserRegion'){
                        field.value = regionId;
                        var options = [];
                        response.data.forEach((opt, i)=>{
                            options.push({
                                label:opt.regionCode,
                                value: opt.id
                            })
                            if( i === response.data.length-1){
                                field.data = options;
                            }
                        }) 
                        if(response.data.length === 0){
                            field.data = []
                        }
                    }
                    else{
                        field.value = values[field.name]
                    }
                    props.push(field);
                    if(i === properties.length-1){ 
                        schema.properties = props; 
                        //console.log(schema)
                        schema.force = true
                        this.setState({schema: schema},()=>{
                            this.setState({addForm: true})
                        })
                    }
                })
        })
        //console.log(values)
    }

    updateRecord(row, status){ 
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`cnEmployees/updateEmployee`, {cnUserStatus: status, id: row.id}).then(res=>{
                //console.log(res.message);
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }



    resendmail(row){
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`common/resendMail`, {userType: "CN", userId: row.id}).then(res=>{ 
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }


    componentDidMount(){ 
        this.setState({schema: schema},()=>{
            this.reloadData();
        })
    }

    handleCloseform(){
        this.setState({addForm: false})
    }


  getActions(params){
    var detail = window.localStorage.getItem('userdetail')
    if(detail !== '' && detail !== undefined && detail !=='{}'){
      var userdetail = JSON.parse(detail);
    return <div>       
            {userdetail.id !== params.row.id &&  checkButtonAccess('User.Staff') === 'W' &&
                <FButton permission_id = "web_edit_employee" permission_label="Show edit employee"
                variant="outlined" 
                size="small" 
                onClick={()=>this.openEdit(params.row)} 
                label="Edit"/>
            }
            {params.row.cnUserStatus==='1' &&  userdetail.id !== params.row.id && checkButtonAccess('User.Staff') === 'W' &&
                <FButton permission_id = "web_status_employee" permission_label="Show status employee"
                variant="contained" 
                size="small" 
                onClick={()=>{this.updateRecord(params.row, 0)}} 
                label="Deactivate"/>
            }
            {params.row.cnUserStatus==='0' && userdetail.id !== params.row.id && checkButtonAccess('User.Staff') === 'W' &&
                <FButton permission_id = "web_status_employee" permission_label="Show status employee"
                variant="contained" 
                size="small" 
                onClick={()=>{this.updateRecord(params.row, 1)}} 
                label="Activate"/>
            }
            {params.row.isUserVerified!==1 && userdetail.id !== params.row.id && params.row.cnUserEmail !== '' && params.row.cnUserEmail !== null &&  checkButtonAccess('User.Staff') === 'W' &&
                <FButton permission_id = "web_resendmail_employee" permission_label="Show resendmail employee"
                variant="contained" 
                size="small" 
                onClick={()=>{this.resendmail(params.row)}} 
                label="Resend Email"/>
            }
            {(userdetail.id === params.row.id  ||  checkButtonAccess('User.Staff') !== 'W' )&& <p style={{paddingLeft:'10px'}}>N/A</p> }   
        </div>
    }
    }
    openEdit(data){  
        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var props=[]; 
        
        properties.forEach((field,i)=>{
            field.value = data[field.name];
            if(field.component === 'Permission'){
                //console.log(field)
               if(data["UserPermissions"] !== '' && data["UserPermissions"] !== undefined){ 
                    var emppermissions = JSON.parse(data["UserPermissions"]) 
                    field.value = emppermissions
               }
            }
            props.push(field);
            if(i === properties.length-1){
                props.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"id",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })
                schema.properties = props; 
                this.setState({schema: schema,selectedRegion: data},()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }

    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest(`cnEmployees/getEmps`).then(response=>{
                var data = [];
                if(response.data.length > 0){
                    response.data.forEach((elmt, i)=>{ 
                        elmt.id = elmt.cnUserId;
                        data.push(elmt);
                        if(i === response.data.length-1){
                            this.setState({employeelist: data, isLoading: false});
                        }
                    })
                }
                else{
                    this.setState({employeelist: data, isLoading: false});
                }
            })
        })
    }
    getPermissionType(){
        var permissiontype = 'Admin' 
        var properties = Object.assign([], this.state.schema.properties); 
        properties.forEach((field,i)=>{
            if(field.name === 'cnUserRole'){
                permissiontype = field.value === '2' ? 'Admin' : 'Staff'
            }  
            if(i === properties.length-1){  
                return permissiontype;
            }
        })

        return permissiontype;
    }

    openAdd(){
        this.setState({schema: schema,selectedEmployee: {}},()=>{
            var schemaobj = Object.assign({}, schema);

            var properties = Object.assign([], this.state.schema.properties);
            var props=[];
            properties.forEach((field,i)=>{
                delete field["value"];
                if(field.name === 'cnUserRegion'){
                    field.data = "region/getRegions"
                    field.dataformat = {
                        "label":"regionCode",
                        "value":"id"
                    }
                }
                props.push(field);
                if(i === properties.length-1){
                    schemaobj.properties = props;
                }
            });
            this.setState({schema:schemaobj}, ()=>{
                this.setState({addForm: true}) 
            })
        })
    }

    render(){
        return <Page title="Castlenova Employees | Astro POS">
                {this.state.isLoading && <Loader show={this.state.isLoading} />}
                <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />

    {!this.state.addForm ? 
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Employee Management
            </Typography>
            {checkButtonAccess('User.Staff') === 'W' && <FButton 
              onClick={()=>this.openAdd()}
              size="large"
              variant="contained"
              label="Add Employee"
              startIcon={getIcon('mdi:plus')}
            />}
          </Stack>

          <Card>
              <TableView
              data={this.state.employeelist} 
              columns={this.state.columns} />
          </Card>
        </Container> : ''
        }
        {this.state.addForm && <Box sx={{ width: '100%' }}> 
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                     {/* <Grid item xs={1}></Grid> */}
                     <Grid item xs={12}> 
                        <Stack spacing={3}> 
                            <FormManager formProps={this.state.schema}  reloadData={(msg)=>this.reloadData(msg)} formFunctions={{
                                onStateChange: this.onStateChange,
                                onUpdateRole: this.onUpdateRole
                           }} closeForm={()=>this.handleCloseform()}/> 
                        </Stack>
                    </Grid>
                    {/* <Grid item xs={1}></Grid>  */}
                </Grid>
            </Box>}
        </Page>
    }
}